"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpTeachersList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_bootstrap_1 = require("react-bootstrap");
var DpCheckbox_1 = require("../../Checkbox/DpCheckbox");
var helpers_1 = require("../../../../api/helpers");
var assets_1 = require("../../../../assets");
var DpTeachersList_styled_1 = require("./DpTeachersList.styled");
var DpSelectAllConfirmationModal_1 = require("../SelectAllConfirmationModal/DpSelectAllConfirmationModal");
var image_1 = __importDefault(require("next/image"));
var DpTeachersList = function (_a) {
    var teachers = _a.teachers, allTeachersSelected = _a.allTeachersSelected, totalRecords = _a.totalRecords, selectHandler = _a.selectHandler, onAllTeacherSelectHandler = _a.onAllTeacherSelectHandler;
    // ------------------------- State
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var _b = (0, react_1.useState)(allTeachersSelected), allChecked = _b[0], setAllChecked = _b[1];
    var _c = (0, react_1.useState)(false), allIndeterminate = _c[0], setAllIndeterminate = _c[1];
    var _d = (0, react_1.useState)(false), selectAllModal = _d[0], setSelectAllModal = _d[1];
    (0, react_1.useEffect)(function () {
        setAllChecked(allTeachersSelected);
    }, [allTeachersSelected]);
    // ------------------------- Actions
    var selectAll = function (checked) {
        setAllChecked(!allChecked);
        setAllIndeterminate(false);
        if (checked && totalRecords > 100) {
            setSelectAllModal(true);
        }
        else {
            selectHandler(checked, teachers.map(function (teacher) { return (__assign(__assign({}, teacher), { selected: teacher.disabled ? true : checked })); }));
        }
    };
    var selectTeacher = function (teacherSelected) {
        return function (checked) {
            var teachersUpdated = teachers.map(function (teacherComposed) {
                return teacherComposed.teacher.id === teacherSelected.id
                    ? __assign(__assign({}, teacherComposed), { selected: checked }) : teacherComposed;
            });
            var allTeachersChecked = teachersUpdated.every(function (teacher) { return teacher.selected; });
            setAllChecked(allTeachersChecked);
            var allTeachersIndeterminate = teachersUpdated.some(function (teacher) { return teacher.selected && !teacher.disabled; });
            setAllIndeterminate(allTeachersChecked === false && allTeachersIndeterminate);
            selectHandler(allTeachersChecked, teachersUpdated);
        };
    };
    var handleEnter = function (e) {
        var _a;
        (_a = e.target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.click();
    };
    var closeAllTeacherModal = function () {
        setAllChecked(false);
        setSelectAllModal(false);
    };
    var selectAllTeacherModal = function () {
        onAllTeacherSelectHandler(closeAllTeacherModal);
    };
    // ------------------------- Render
    return ((0, jsx_runtime_1.jsxs)(DpTeachersList_styled_1.StyledTeachersList, { children: [teachers.length > 0 ? ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.ListGroup, { as: "ul", children: [(0, jsx_runtime_1.jsxs)(react_bootstrap_1.ListGroup.Item, { as: "li", className: "all-row", tabIndex: 0, onKeyDown: (0, helpers_1.handleButtonPress)(handleEnter), "aria-label": t('shareAssessmentModal.labelAllTeachers', {
                            totalTeachers: teachers.length,
                        }), children: [(0, jsx_runtime_1.jsx)(DpCheckbox_1.DpCheckbox, { changeHandler: selectAll, checked: allChecked, indeterminate: allIndeterminate && !allChecked, ariaLabelledbyId: "all-teachers" }), (0, jsx_runtime_1.jsx)("span", { className: "fw-bold", id: "all-teachers", children: t('shareAssessmentModal.allTeachers') })] }, "all"), teachers.map(function (_a) {
                        var teacher = _a.teacher, selected = _a.selected, disabled = _a.disabled;
                        return ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.ListGroup.Item, { as: "li", className: "student", tabIndex: 0, onKeyDown: (0, helpers_1.handleButtonPress)(handleEnter), "aria-label": t('shareAssessmentModal.labelTeacher', {
                                name: "".concat(teacher.lastName, " ").concat(teacher.firstName),
                            }), children: [(0, jsx_runtime_1.jsx)(DpCheckbox_1.DpCheckbox, { changeHandler: selectTeacher(teacher), checked: selected, ariaLabelledbyId: "teacher-".concat(teacher.id), disabled: disabled }), (0, jsx_runtime_1.jsxs)("span", { id: "teacher-".concat(teacher.id), className: "teacher-name ".concat(disabled ? 'disabled' : ''), children: [teacher.lastName, ", ", teacher.firstName] })] }, teacher.id));
                    })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "illustration-no-items", children: [(0, jsx_runtime_1.jsx)(image_1.default, { alt: "", role: "presentation", src: assets_1.SvgImages.emptyStateGlass, width: 140, height: 142 }), (0, jsx_runtime_1.jsx)("h2", { className: "h3", children: t('shareAssessmentModal.noTeachersFound') })] })), selectAllModal && ((0, jsx_runtime_1.jsx)(DpSelectAllConfirmationModal_1.DpSelectAllConfirmationModal, { show: selectAllModal, closeModal: closeAllTeacherModal, selectHandler: selectAllTeacherModal }))] }));
};
exports.DpTeachersList = DpTeachersList;
exports.default = exports.DpTeachersList;
